<template>
  <div class="columns login-columns is-vcentered is-centered">
    <div v-if="leftSideVisiblity" id="particles-js" class="interactive-bg column is-flex">
      <div class="columns is-vcentered is-centered" style="width:100%;">
        <div :class="'column ' + (isSignUp ? 'is-9' : 'is-7')">
          <SignUpInfo v-if="isSignUp" />
          <figure v-else class="image is-flex" style=" justify-content: center;">
            <GearMenu />
          </figure>
        </div>
      </div>
    </div>
    <div :class="'login column ' + formColumnClass">
      <section style="padding-top:1rem;">
        <div class="login-logo has-text-centered">
          <!-- <div class="login-logo">
            <img src="../assets/logo-120.png" style="margin-left:37px;" />
            <div>
              <b>{{ $t('title.onlineInternalAudit') }}</b>
            </div>
          </div>-->
          <a :href="websiteUrl">
            <img src="../assets/logo.png" style="margin-left:37px;" />
            <div>
              <b>{{ $t('title.onlineInternalAudit') }}</b>
            </div>
          </a>
        </div>
        <router-view></router-view>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GearMenu from '../components/GearMenu.vue'
import SignUpInfo from '../components/SignUpInfo.vue'
import { WEBSITE_URL } from '../_helpers/config'
// import 'particles.js';

export default {
  components: { GearMenu, SignUpInfo },
  data() {
    return {
      leftSideVisiblity: true,
      websiteUrl: WEBSITE_URL
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    isSignUp() {
      return this.$route.name === 'signup'
    },
    formColumnClass() {
      if (!this.leftSideVisiblity) return 'has-membership-background'
      // The sign-up form has two fields side by side, too tight at a third of the screen.
      return this.isSignUp ? 'is-5' : 'is-4'
    }
  },
  mounted() {
    this.checkVisibility()
    // this.initParticles();
    document.querySelector('body').classList.remove('has-navbar-fixed-top')
  },
  beforeUpdate() {
    this.checkVisibility()
  },
  methods: {
    checkVisibility() {
      if (this.$route.name === 'payment') {
        this.leftSideVisiblity = false
      } else {
        this.leftSideVisiblity = window.innerWidth > 769
      }
    },
    initParticles() {
      window.particlesJS('particles-js', {
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              value_area: 700
            }
          },
          color: {
            value: '#ffffff'
          },
          shape: {
            type: 'circle',
            stroke: {
              width: 0,
              color: '#000000'
            },
            polygon: {
              nb_sides: 5
            }
          },
          opacity: {
            value: 0.5,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false
            }
          },
          size: {
            value: 3,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false
            }
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: '#ffffff',
            opacity: 0.4,
            width: 1
          },
          move: {
            enable: true,
            speed: 6,
            direction: 'none',
            random: false,
            straight: false,
            out_mode: 'out',
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200
            }
          }
        },
        interactivity: {
          detect_on: 'canvas',
          events: {
            onhover: {
              enable: true,
              mode: 'grab'
            },
            onclick: {
              enable: true,
              mode: 'push'
            },
            resize: true
          },
          modes: {
            grab: {
              distance: 140,
              line_linked: {
                opacity: 1
              }
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3
            },
            repulse: {
              distance: 200,
              duration: 0.4
            },
            push: {
              particles_nb: 4
            },
            remove: {
              particles_nb: 2
            }
          }
        },
        retina_detect: true
      })
    }
  }
}
</script>

<style>
.interactive-bg {
  min-height: 100vh;
  align-self: stretch;
  /* background-color: #31b4cb; */
  background-color: rgb(251, 251, 251);
  -webkit-box-shadow: inset 12px 4px 44px -20px rgba(71, 71, 71, 1);
  -moz-box-shadow: inset 12px 4px 44px -20px rgba(71, 71, 71, 1);
  box-shadow: inset 12px 4px 44px -20px rgba(71, 71, 71, 1);
  padding: 0px;
}
@media (max-width: 769px) {
  .interactive-bg {
    display: none !important;
  }
}

.login-button {
  margin-top: 20px;
  margin-bottom: 20px;
  min-width: 150px;
}

.login-logo {
  margin: 0 auto;
  margin-bottom: 35px;
}

.login-logo a {
  color: #4a4a4a !important;
}

.login-columns {
  margin: 0px !important;
}

.membership-header {
  padding-bottom: 30px;
}

.has-membership-background {
  background-color: rgb(251, 251, 251);
}
</style>
